module.exports = __webpack_public_path__ + "img/04_active.f329bc28.png";